import React, { useEffect, useState, useCallback } from "react";
import { Grid } from "@material-ui/core";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { profileRequestStatusSchema } from "app/components/mvp/formWidget/model/profileRequestStatus";
import { profileRequestStatusUiSchema } from "app/components/uiSchema/profileRequestStatusUiSchema";
import { config } from "utilities/config";
import { post } from "app/services/api";
import FormWidget from "app/components/mvp/formWidget";
import moment from "moment";
import axios from "axios";
import { formatData } from "utilities/datatable";

function ViewProfileRequestById(props) {
  const { id } = useParams();
  const [profileRequestFormData, setProfileRequestFormData] = useState({});
  const dispatch = useDispatch();

  const profileRequest = {
    widgetType: "updateContact",
    formSchema: profileRequestStatusSchema,
    uiSchema: profileRequestStatusUiSchema,
    formData: profileRequestFormData,
    apiURL: config.teleportal.submitForm.Update,
    payloadSchema: {},
    entityType: "ctpt_employeeprofilerequestses",
    formUischema: "",
    button1Label: "",
    button2Label: "Go Back",
    payloadSubmit: {},
    contactId: "",
    goBackPage: "/saice-connect/employment/view-profile-requests",
    button2GoBack: true,
    historyUrl: "",
  };

  const [profileRequestOptions, setProfileRequestOptions] = useState(profileRequest);

  const updateFormData = useCallback((entityType, formData) => {
    profileRequest.formData = formData;
    profileRequest.initialFormData = formData;
    setProfileRequestOptions(profileRequest);
    setProfileRequestFormData(formData);
  }, []);

  const getProfileRequestDetails = useCallback(() => {
    const api = `${config.teleportal.env}${config.teleportal.submitForm.get}`;
    const payload = {
      recordtype: "ctpt_employeeprofilerequestses",
      idfield: "ctpt_employeeprofilerequestsid",
      properties: [
        "ctpt_employeeprofilerequestsid",
        "ctpt_name",
        "ctpt_daterequested",
        "ctpt_approved",
        "ctpt_rejected",
        "ctpt_reasonforcontacting"
      ],
      formattedFields: [
        "_ctpt_employer_value",
        "_ctpt_employee_value"
      ],
      filter: {
        globalfilter: "",
        globalAndOperator: false,
        fieldAndOperator: false,
        filterfields: [
          {
            field: "ctpt_employeeprofilerequestsid",
            searchvalue: id,
            type: "guid"
          }
        ]
      },
      continuationToken: "",
      pazesize: "1000"
    };

    axios.post(api, payload, {
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json"
      }
    })
      .then((res) => {
        console.log("Full API Response:", JSON.stringify(res.data, null, 2));
        try {
          const responseData = res.data?.data || res.data?.Data;

          if (!res.data || !responseData || !Array.isArray(responseData)) {
            console.error("Invalid response structure:", res.data);
            dispatch({
              type: "SET_STATUS",
              payload: {
                message: "Failed to load profile request details",
                code: "",
                display: "show",
                severity: "error",
              },
            });
            return;
          }

          // Extract records from the nested structure
          const extractedRecords = [];

          responseData.forEach((outerItem) => {
            if (outerItem && outerItem.data && Array.isArray(outerItem.data)) {
              const firstItem = outerItem.data[0];

              if (firstItem && firstItem.name !== undefined) {
                // The data array directly contains field objects (name/value pairs)
                extractedRecords.push({
                  id: outerItem.id,
                  data: outerItem.data
                });
              } else if (firstItem && firstItem.data && Array.isArray(firstItem.data)) {
                // The data array contains nested items
                outerItem.data.forEach((innerItem) => {
                  if (innerItem && innerItem.data && Array.isArray(innerItem.data)) {
                    const firstField = innerItem.data[0];
                    if (firstField && firstField.name !== undefined) {
                      extractedRecords.push({
                        id: innerItem.id || outerItem.id,
                        data: innerItem.data
                      });
                    }
                  }
                });
              }
            }
          });

          if (extractedRecords.length > 0) {
            // Format the extracted records using formatData utility
            const wrappedResponse = { data: extractedRecords };
            const formattedRequests = formatData(wrappedResponse);
            
            if (formattedRequests && formattedRequests.length > 0) {
              const record = formattedRequests[0];
              const formData = {};
              
              // Process the formatted record
              if (record.ctpt_daterequested) {
                formData.ctpt_daterequested = moment(record.ctpt_daterequested).format("MM/DD/YYYY");
              }
              
              if (record.ctpt_approved !== undefined) {
                // Display approved as Yes/No
                if (record.ctpt_approved === true || record.ctpt_approved === "true" || record.ctpt_approved === 1 || record.ctpt_approved === "1") {
                  formData.ctpt_approved = "Yes";
                } else {
                  formData.ctpt_approved = "No";
                }
              } else {
                formData.ctpt_approved = "No";
              }

              if (record.ctpt_rejected === true || record.ctpt_rejected === "true" || record.ctpt_rejected === 1 || record.ctpt_rejected === "1") {
                formData.ctpt_rejected = "Yes";
              } else {
                formData.ctpt_rejected = "No";
              }
              
              // Handle employer name - use formatted value if available
              // Map to ctpt_employer as expected by the schema
              if (record["_ctpt_employer_value@OData.Community.Display.V1.FormattedValue"]) {
                formData.ctpt_employer = record["_ctpt_employer_value@OData.Community.Display.V1.FormattedValue"];
              } else if (record["_ctpt_employer_value"]) {
                formData.ctpt_employer = record["_ctpt_employer_value"];
              }
              
              // Add other fields
              if (record.ctpt_name) formData.ctpt_name = record.ctpt_name;
              if (record.ctpt_reasonforcontacting) formData.ctpt_reasonforcontacting = record.ctpt_reasonforcontacting;
              if (record.ctpt_employeeprofilerequestsid) formData.ctpt_employeeprofilerequestsid = record.ctpt_employeeprofilerequestsid;
              
              updateFormData({}, formData);
            } else {
              console.error("formatData returned empty array");
              dispatch({
                type: "SET_STATUS",
                payload: {
                  message: "Failed to load profile request details",
                  code: "",
                  display: "show",
                  severity: "error",
                },
              });
            }
          } else {
            console.warn("No records extracted from response");
            dispatch({
              type: "SET_STATUS",
              payload: {
                message: "Profile request not found",
                code: "",
                display: "show",
                severity: "error",
              },
            });
          }
        } catch (parseError) {
          console.error("Error parsing API response:", parseError);
          dispatch({
            type: "SET_STATUS",
            payload: {
              message: "Failed to load profile request details",
              code: "",
              display: "show",
              severity: "error",
            },
          });
        }
      })
      .catch((error) => {
        console.log("Error fetching profile request:", error);
        dispatch({
          type: "SET_STATUS",
          payload: {
            message: "Failed to load profile request details",
            code: "",
            display: "show",
            severity: "error",
          },
        });
      });
  }, [id, dispatch, updateFormData]);

  useEffect(() => {
    if (id && id.length > 0) {
      getProfileRequestDetails();
    }
  }, [id, getProfileRequestDetails]);

  const getResponse = (res) => {
    if (res.data.id) {
      dispatch({
        type: "SET_STATUS",
        payload: {
          message: "Record updated successfully",
          code: "",
          display: "show",
          severity: "success",
        },
      });
    } else {
      dispatch({
        type: "SET_STATUS",
        payload: {
          message: "Record update failed",
          code: "",
          display: "show",
          severity: "error",
        },
      });
    }
  };

  return (
    <Grid container spacing={0} justify="center">
      <Grid item xs={12} md={9}>
        <FormWidget
          options={profileRequestOptions}
          updateFormData={updateFormData}
          successResponse={getResponse}
        />
      </Grid>
    </Grid>
  );
}

export default ViewProfileRequestById;
